<template>
<v-app id="app">
  <!-- <CoreToolbar></CoreToolbar> -->
 <!-- <CoreDrawer></CoreDrawer> -->
 <CoreView></CoreView> 
 </v-app>
</template>
<script>


import AppBar from '@/components/common/AppBar'

import CoreDrawer from '@/components/common/Drawer'
import CoreToolbar from '@/components/common/Toolbar'

import CoreView from '@/components/common/View'

import Footer from '@/components/common/Footer.vue';

import { http } from '@/services/config';



export default {
  name: 'App',

  components: {
    CoreToolbar,
    CoreDrawer,
    CoreView,
    AppBar,
    Footer
  },

  data: () => ({
    refreshing: false,
      registration: null,
      snackBtnText: '',
      snackWithBtnText: '',
      snackWithButtons: false,
      timeout: 6000
  }),
  created() {
    // Listen for swUpdated event and display refresh snackbar as required.
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true });
    // Refresh all open app tabs when a new service worker is installed.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return;
        this.refreshing = true;
      window.location.reload();
    });
  },
  mounted() {
    this.verificarSesion();
  },
  methods:{
    verificarSesion() {
      const token = localStorage.getItem('token');
      if (!token) {
        this.limpiarSesion();
        return;
      }

      // Verificar si ya expiró por fecha local
      const expiresAt = localStorage.getItem('expiresAt');
      if (expiresAt && new Date(expiresAt) < new Date()) {
        this.limpiarSesion();
        return;
      }

      // Verificar con el servidor si el token sigue válido
      http.get('api/user-info', { skipAuthInterceptor: true })
        .then((res) => {
          // Token válido — sincronizar roles con el servidor
          const data = res.data;
          if (data.roles) {
            this.$store.commit('setRoles', data.roles);
          }
          if (data.identificador) {
            this.$store.commit('setIdentificador', data.identificador);
          }
        })
        .catch(() => {
          // Token inválido/expirado en servidor → limpiar
          this.limpiarSesion();
        });
    },
    limpiarSesion() {
      localStorage.removeItem('token');
      localStorage.removeItem('expiresAt');
      localStorage.removeItem('identificador');
      localStorage.removeItem('linkPhoto');
      localStorage.removeItem('roles');
      this.$store.commit('setLogueado', false);
      this.$store.commit('setIdentificador', '');
      this.$store.commit('setLinkPhoto', '');
      this.$store.commit('setRoles', []);
    },
    showRefreshUI(e) {
      this.registration = e.detail;
      this.snackBtnText = 'Refresh';
      this.snackWithBtnText = 'New version available!';
      this.snackWithButtons = true;
    },
    refreshApp() {
      this.snackWithButtons = false;
      if (!this.registration || !this.registration.waiting) { return; }
      this.registration.waiting.postMessage('skipWaiting');
    },
  }
};




</script>


<style>

/* estilos aplicados para el icono de google recaptcha */
.grecaptcha-badge {
  right: auto !important;
    left: 0;
    width: 70px !important;

    -webkit-transition: width 0.5s ease-in-out !important;
    -moz-transition: width 0.5s ease-in-out !important;
    -o-transition: width 0.5s ease-in-out !important;
    transition: width 0.5s ease-in-out !important;

    &:hover {
        width: 256px !important;
    }
}


</style>



